import { pushToDataLayer } from '@/lib/pushToDataLayer.ts';

export const trackPositionSelected = (positionName: string) => {
  pushToDataLayer({
    event: 'position_selected',
    position: positionName,
  });
};
